<template>
        <CarouselSlider 
          :autoplay="true"
          :interval="3000"
          :pause-on-hover="true"
          :show-controls="true"

        >
              <!-- Custom content for each slide using slots -->
              <template :slot="'slide-' + (i + 1)" v-for="(item,i) in s.items">
                <div :style="'display: flex; margin: auto; justify-content: center; align-items: center;text-align: center; width: 100%; height: 100%; background-image: url('+item.image+'); background-size: cover'">
                    <div class="bonus-title">
                        <img src="https://cf.europebet.com/prod/content/sliders/images/a65a62e9-bf52-4f5d-a72d-310979fe2af3.webp"/>
                    </div>
                </div>
              </template>
              <!-- Other slides will use default content -->
        </CarouselSlider>
</template>

<script>
    import CarouselSlider from '@/components/sportsbook/widget/slider';

    export default {
        name: 'slider',
        props: ['id'],
        components: { CarouselSlider },
        data () {
            return {
                s: null
            }
        },
        mounted() {
            this.fetchSlider()
        },
        methods: {
            fetchSlider() {
                this.$http.get(api + 'api/v2/slides/'+this.id).then(response => {
                    this.s = response.body
                })
            }
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.bonus-title {
    backdrop-filter: blur(10px);
    padding: 10px 40px;
}
.bonus-title h2{
    color: orange;
    font-size: 0.6em;
}
</style>


// WEBPACK FOOTER //
// src/components/widget/slider.vue